import { EstateType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { EstateRelatedDto } from "@1games-ru/region-shared/dist/types/estate/estate";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import clsx from "clsx";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { House3Icon } from "@/shared/icons";
import { Tabs } from "@/shared/ui";
import PlayerMenuContent from "@/domains/playerMenu/components/PlayerMenuContent";
import PlayerMenuContentProgress from "@/domains/playerMenu/components/PlayerMenuContentProgress";
import PlayerMenuContentTitle from "@/domains/playerMenu/components/PlayerMenuContentTitle";
import PlayerMenuCharacterEstateCard from "@/domains/playerMenu/components/character/estate/PlayerMenuCharacterEstateCard";

enum Tab {
  Owner = "Owner",
  Tenant = "Tenant",
}

export default function PlayerMenuCharacterEstateContainer() {
  const { t } = useTranslation("playerMenu");
  const [estates, setEstates] = useState<EstateRelatedDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currTab, setCurrTab] = useState<Tab>(Tab.Owner);

  const tabs = useMemo(
    () => [
      { value: Tab.Owner, label: t(`playerMenu.tab.Estate${Tab.Owner}`) },
      { value: Tab.Tenant, label: t(`playerMenu.tab.Estate${Tab.Tenant}`) },
    ],
    [],
  );

  const getEstates = useCallback(async () => {
    const response = await EstateMpProvider.getRelated();

    if (response instanceof RpcMpProviderFailedResponse) {
      toast.error("Не удалось загрузить список недвижимости");
      console.log("Failed fetch loadSlots() - EstateMpProvider.getRelated()", response);
      return;
    }

    const resultEstates = [];
    response.data.items.forEach((item) => {
      if (item.entity.type === EstateType.HotelRoom) {
        return;
      }

      resultEstates.push(item);
      setEstates(resultEstates);
    });

    setIsLoading(false);
  }, []);

  useEffect(() => {
    getEstates();
  }, []);

  const listEstates = useMemo(() => {
    switch (currTab) {
      case Tab.Owner:
        return estates.filter((item) => item.isOwner);
      case Tab.Tenant:
        return estates.filter((item) => item.isTenant);
      default:
        return estates;
    }
  }, [currTab, estates]);

  const countOwnerEstate = useMemo(() => estates.map((item) => item.isOwner).length, [estates]);

  const header = (
    <div className="">
      <PlayerMenuContentTitle>{t("playerMenu.tabTitle.Estate")}</PlayerMenuContentTitle>
      <div className="flex items-center justify-between">
        <Tabs tabs={tabs} value={currTab} onClick={(value) => setCurrTab(value as Tab)} />
        <div className="flex items-center">
          <House3Icon size={16} className="text-white/10" />
          <div className="text-12 leading-3 font-bold text-white/70 ml-2.5">
            НЕДВИЖИМОСТИ ВО ВЛАДЕНИИ:
          </div>
          <div
            className={clsx(
              "flex items-center justify-between h-[1.375rem] px-1.5 bg-white/5 rounded-[0.375rem] ml-1",
              "text-12 font-bold tabular-nums leading-3",
            )}
          >
            {countOwnerEstate}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <PlayerMenuContent header={header}>
      {isLoading ? (
        <PlayerMenuContentProgress />
      ) : (
        <div className="flex flex-wrap gap-5">
          {listEstates.length > 0 && (
            <>
              {estates.map((item) => (
                <PlayerMenuCharacterEstateCard key={item.id} {...item} />
              ))}
            </>
          )}
        </div>
      )}
    </PlayerMenuContent>
  );
}
